module.exports = {
    "sample": {
        "title": "sample",
        "thumbnail": "/assets/images/pdf-placeholder.jpg",
        "document": "/assets/docs/sample.pdf",
        "teaser": "Get more details about **admissions requirements**, **program highlights**, and your **next steps**."
    },
}